import { render, staticRenderFns } from "./LandListNew.vue?vue&type=template&id=1d3cfc6a&scoped=true"
import script from "./LandListNew.vue?vue&type=script&lang=js"
export * from "./LandListNew.vue?vue&type=script&lang=js"
import style0 from "./LandListNew.vue?vue&type=style&index=0&id=1d3cfc6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3cfc6a",
  null
  
)

export default component.exports